export const API_KEY="AIzaSyCDCoEGdmK1qtAipv3_u9BxQ4stTMaSUtA"

export default API_KEY